import * as PropTypes from "prop-types";

import React from "react";
import { Checkbox } from "@mui/material";

const CNormalCheckbox = ({ checked, onChange, padding, disabled }) => {
  return (
    <Checkbox
      onChange={onChange}
      checked={checked}
      sx={{
        color: "#F15E30",
        "&.Mui-checked": { color: "#F15E30" },
        padding: padding && "0px",
      }}
      disabled={disabled}
    />
  );
};

CNormalCheckbox.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};

export default CNormalCheckbox;
